 <template>
  <div class="light_lesson">
    <div class="head_item" :style="{height:(data.unitAnalysis.length != 0 ? '3.5rem' : '2.5rem')}">
      <i @click="exit_enevt"></i>
      <template v-if="data.unitAnalysis && data.unitAnalysis.length != 0">
        <h2 v-if="data.userName">
          {{data.userName.length > 3 ? data.userName.substr(0,3) + '...' : data.userName}}的
          <span>考前冲刺方案</span>
        </h2>
        <div class="word_box">
          <p
            class="name"
          >{{data.userName.length > 3 ? data.userName.substr(0,3) + '...' : data.userName}}家长你好：</p>
          <p class="word">
            期中考试临近，基于作业盒子大数据，
            发现{{data.userName}}在{{data.badUnitName}}有薄弱知识点。
          </p>
        </div>
      </template>
      <h2 v-else>
        <span>重难点</span>直播讲解
        <br />&nbsp;&nbsp;&nbsp;&nbsp;针对性
        <span>补强练习</span>
      </h2>
      <img src="../../assets/images/light_lesson/head_logo.png" />
    </div>
    <div v-if="data.unitAnalysis && data.unitAnalysis.length != 0" class="content_analysis">
      <h3>{{data.userName}}的期中薄弱章节分析</h3>
      <h4>攻克以下知识点，有助于达成考试目标</h4>
      <div class="list" v-for="(k , i) in data.unitAnalysis">
        <p class="list_mes">
          {{k.unitName}}
          <span>本节有{{k.wrongQuestionCount}}道错题</span>
        </p>
        <div class="list_p_box">
          <p :style="{width: k.unitScore+'%'}" class="p_box_c"></p>
          <p
            :style="{left: k.unitScore+'%',width: (k.goalScore - k.unitScore)+'%'}"
            class="g_box_c"
          >
            <img src="../../assets/images/light_lesson/g_arrow.png" />
          </p>
        </div>
        <div class="list_s_box">
          <p class="fl_p">
            <span class="score">
              {{k.unitScore}}
              <font style="font-size: .28rem">分</font>
            </span>
            <span class="word">当前掌握度</span>
          </p>
          <p class="fr_p">
            <span class="score">
              {{k.goalScore}}
              <font style="font-size: .28rem">分</font>
            </span>
            <span class="word">目标掌握度</span>
          </p>
        </div>
      </div>
    </div>
    <div v-if="data.personalityPlan" class="content_plan" ref="content_plan">
      <h3>{{data.userName}}的个性化提升方案</h3>
      <h4>{{data.liveDuring}}</h4>
      <div v-if="data.unitAnalysis && data.unitAnalysis.length != 0" class="plan_item_a">
        <div class="item">
          <p class="title">
            <span>{{data.personalityPlan.wrongRiseCount}}次</span>个性化错题提升
          </p>
          <div class="plan_box">
            <p>帮你消灭</p>
            <p>本学期{{data.personalityPlan.wrongQuestionCount}}道错题</p>
            <img src="../../assets/images/light_lesson/plan_box_bg_2.png" />
          </div>
        </div>
        <div class="item">
          <p class="title">
            <span>{{data.personalityPlan.unitExamCount}}次</span>课后定制测试
          </p>
          <div class="plan_box">
            <p>重点检测你的</p>
            <p>{{data.personalityPlan.knowledgeCount}}个薄弱知识点</p>
            <img src="../../assets/images/light_lesson/plan_box_bg_1.png" />
          </div>
        </div>
      </div>
      <div v-else class="plan_item_b">
        <div class="item">
          <div class="plan_box">
            <p>
              <font style="font-size: .48rem">{{data.personalityPlan.wrongRiseCount}}</font>次
            </p>
            <p>针对性错题提升</p>
            <img src="../../assets/images/light_lesson/plan_box_bg_2.png" />
          </div>
          <p class="title">
            帮你消灭本学期
            <span>所有错题</span>
          </p>
        </div>
        <div class="item">
          <div class="plan_box">
            <p>
              <font style="font-size: .48rem">{{data.personalityPlan.unitExamCount}}</font>次
            </p>
            <p>课后定制测试</p>
            <img src="../../assets/images/light_lesson/plan_box_bg_1.png" />
          </div>
          <p class="title">
            重点提升
            <span>薄弱易错知识点</span>
          </p>
        </div>
      </div>
      <img src="../../assets/images/light_lesson/plan_bg.png" />
    </div>
    <div v-if="data.studyPlan" class="content_program" ref="content_program">
      <h3>冲刺学习大纲</h3>
      <h4>
        {{data.teachingGrade}}
        <span class="line"></span>
        {{data.teachingName}}
      </h4>
      <div class="item">
        <div class="list" v-for="(k,i) in data.studyPlan">
          <span>{{i < 9 ? '0' + (i + 1) : i + 1}}</span>
          <div class="r_box">
            <p class="title">{{k.name}}</p>
            <p class="time">{{k.time}}</p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="data.teacherIntroduce" class="content_teacher" ref="content_teacher">
      <h3>老师介绍</h3>
      <div class="item">
        <div class="list p_r">
          <img :src="data.teacherIntroduce.lecturer.headPhoto" />
          <h4>{{data.teacherIntroduce.lecturer.name}}</h4>
          <p>{{data.teacherIntroduce.lecturer.description}}</p>
        </div>
        <span class="v_s">vs</span>
        <div class="list p_l">
          <img :src="data.teacherIntroduce.adviser.headPhoto" />
          <h4>{{data.teacherIntroduce.adviser.name}}</h4>
          <p>{{data.teacherIntroduce.adviser.description}}</p>
        </div>
      </div>
    </div>
    <div class="content_flow" ref="content_detail">
      <h3>学习流程</h3>
      <img src="../../assets/images/light_lesson/study_flow.png" />
    </div>
    <div class="bottom_btn">
      <div class="l_box">
        <h3>{{(data.price/100).toFixed(2)}}</h3>
        <span>{{data.liveDate}}</span>
        <span>¥{{(data.originPrice/100).toFixed(2)}}</span>
      </div>
      <div v-if="data.isBuy" class="r_box">已报名</div>
      <div v-if="!data.isBuy && orderId == 0" class="r_box" @click="pay_event">报名提升</div>
      <div v-if="orderId != 0 && !data.isBuy" class="r_box" @click="go_pay">去支付</div>
    </div>
    <lesson_loading v-if="loadingLock" :status="status"></lesson_loading>
  </div>
</template>

<script>
import ajax from "@/api/lightAjax";
import utils from "@/assets/js/utils";
import lesson_loading from "@/components/common/fit_iphonex/lesson_loading_fit_iphonex.vue";
let vm = null;
window.callback = function(obj) {
  vm.creatOrder(JSON.parse(obj));
};
window.onVisible = function() {
  vm.initData();
};
let publicPath = {
  test: "https://qa.knowbox.cn:8018",
  preview: "https://preshark.knowbox.cn:8042",
  production: "https://stuapi.knowbox.cn"
};
export default {
  name: "light_lesson",
  data() {
    return {
      token: "",
      courseId: "",
      source: "",
      version: "",
      productId: "",
      data: {},
      orderId: 0,
      loadingLock: true,
      status: "loading",
      btn_status: true,
      anchor: 1,
      plan_offsetTop: "",
      program_offsetTop: "",
      teacher_offsetTop: "",
      detail_offsetTop: ""
    };
  },
  watch: {
    data: function() {
      let self = this;
      this.$nextTick(function() {
        setTimeout(function() {
          self.plan_offsetTop = self.$refs.content_plan.offsetTop;
          self.program_offsetTop = self.$refs.content_program.offsetTop;
          self.teacher_offsetTop = self.$refs.content_teacher.offsetTop;
          self.detail_offsetTop = self.$refs.content_detail.offsetTop;
          window.addEventListener("scroll", self.handleScroll);
        }, 1000);
      });
    }
  },
  methods: {
    initData: async function() {
      let self = this;
      const [resp] = await ajax.all([
        ajax.get("/light/live-introduce/exam", {
          params: {
            token: self.token,
            courseId: self.courseId
          }
        })
      ]);
      console.log(resp.data.data);
      if (resp.data.code == 99999) {
        this.loadingLock = false;
        this.data = resp.data.data;
        this.productId = this.data.productId;
        this.orderId = this.data.orderId;
        utils.sendLog(
          {
            token: self.token,
            version: self.version,
            source: self.source,
            extensionJson: {
              courseID: self.courseId,
              studydata: self.data.unitAnalysis.length == 0 ? 0 : 1,
              anchor: self.anchor,
              from: utils.getQueryString("from")
            }
          },
          "hzxx453"
        );
      } else {
        this.loadingLock = true;
        this.status = "error";
      }
    },
    creatOrder: async function(obj) {
      let self = this;
      const [resp] = await ajax.all([
        ajax.post("/light/live-order/order-add", {
          token: self.token,
          source: obj.source,
          version: obj.version,
          productId: self.productId,
          identity: "parent",
          userSource: "LIVENETSCHOOL",
          clientChannel: obj.channel,
          clientVersion: obj.appVersion,
          deviceBrand: obj.platform,
          deviceModel: obj.platform,
          OSName: obj.platform,
          OSVersion: obj.deviceVersion,
          pageChannel: utils.getQueryString("pageChannel"),
          channel: "i_xhjz"
        })
      ]);

      if (resp.data.code == 99999) {
        this.btn_status = true;
        this.orderId = resp.data.data.orderId;
        if (this.data.price == 0) {
          return this.$router.push({ path: "/lightLesson/pay_sucess" });
        }
        let url =
          window.location.origin +
          "/#/lightLesson/pay_sucess?hideTitleBar=1&courseID=" +
          self.courseId +
          "&token=" +
          self.token +
          "&source=" +
          self.source +
          "&version=" +
          self.version;
        window.location =
          "hybird://method/buyLiveCourse?orderId=" +
          self.orderId +
          "&payHost=" +
          escape(publicPath[process.env.VUE_APP_INTER]) +
          "&orderInfoPath=/light/live-order/order-info&successUrl=" +
          escape(url) +
          "&showAddress=0&chargePath=light/live-order/order-add-pay-obj&verifyPath=light/live-order/order-verify";
      } else {
        this.btn_status = true;
      }
    },
    pay_event: async function() {
      let self = this;
      if (!this.btn_status) return;
      this.btn_status = false;
      utils.sendLog(
        {
          token: self.token,
          version: self.version,
          source: self.source,
          extensionJson: {
            courseID: self.courseId
          }
        },
        "hzxx454"
      );
      // let obj = '{"deviceVersion":"11.0.1","version":"332","channel":"AppStore","buildVersion":"3.3.3.1","deviceId":"563E7F43-6399-440C-99E6-F163A95DA408","source":"iOSRCParent","deviceType":"iOSx8664Simulator","packageName":"com.appKnowin.PRapidCalculation","platform":"iOS","appName":"RCParent","token":"MxTARa2dBPmM5QtYb1mdLkoZ_xmE6rNau_v653LR9hPc0k7zbqmdHiYesG9kI0SFK4DGaFPsMpiEUTnF3Ij0D4SO-Dx4JUwqF02DC86hg_o\/","mode":0,"appVersion":"3.3.2"}'
      // this.creatOrder(JSON.parse(obj))
      window.location = "hybird://method/nativeToJS?funcName=callback";
    },
    go_pay() {
      let url =
        window.location.origin +
        "/#/lightLesson/pay_sucess?hideTitleBar=1&courseID=" +
        this.courseId +
        "&token=" +
        this.token +
        "&source=" +
        this.source +
        "&version=" +
        this.version;
      window.location =
        "hybird://method/buyLiveCourse?orderId=" +
        this.data.orderId +
        "&payHost=" +
        escape(publicPath[process.env.VUE_APP_INTER]) +
        "&orderInfoPath=/light/live-order/order-info&successUrl=" +
        escape(url) +
        "&showAddress=0&chargePath=light/live-order/order-add-pay-obj&verifyPath=light/live-order/order-verify";
    },
    exit_enevt() {
      window.location = "hybird://method/exit";
    },
    handleScroll: function() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop >= this.detail_offsetTop) {
        console.log("课程详情");
        this.anchor = 4;
      } else if (scrollTop >= this.teacher_offsetTop) {
        console.log("老师介绍");
        this.anchor = 3;
      } else if (scrollTop >= this.program_offsetTop) {
        console.log("学习计划");
        this.anchor = 2;
      } else if (scrollTop >= this.plan_offsetTop) {
        console.log("个性化提升方案");
        this.anchor = 1;
      }
    }
  },
  components: {
    lesson_loading
  },
  created: async function() {
    let self = this;
    vm = this;
    console.log(process.env.VUE_APP_INTER);
    self.token = utils.getQueryString("token");
    self.courseId = utils.getQueryString("courseId");
    self.source = utils.getQueryString("source");
    self.version = utils.getQueryString("version");
    self.initData();
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/font/font.scss";
.light_lesson {
  background: #fff;
  &:before {
    content: "";
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: constant(safe-area-inset-top);
    height: env(safe-area-inset-top);
    background-color: #c1e6ff;
    z-index: 9998;
  }
  .head_item {
    padding-top: 0.9rem;
    padding-left: 0.9rem;
    position: relative;
    height: 3.5rem;
    background-color: #c1e6ff;
    i {
      position: absolute;
      left: 0.2rem;
      top: 0.2rem;
      display: inline-block;
      width: 0.6rem;
      height: 0.6rem;
      background: url("../../assets/images/light_lesson/arrow_back.png") 0 0 /
        cover no-repeat;
      vertical-align: text-bottom;
    }
    h2 {
      font-size: 0.52rem;
      color: #fff;
      font-family: "FZY4JW";
      line-height: 0.6rem;
      text-shadow: 0 4px 4px #a3daff;
      span {
        color: #44b4ff;
      }
    }
    img {
      position: absolute;
      bottom: 0;
      right: 0.22rem;
      width: 2.15rem;
    }
    .word_box {
      position: relative;
      width: 4.1rem;
      &:before {
        content: "";
        position: absolute;
        top: 0;
        left: -0.28rem;
        width: 0.18rem;
        height: 0.14rem;
        background: url("../../assets/images/light_lesson/quotes_l.png") 0 0 /
          cover no-repeat;
      }
      &:after {
        content: "";
        position: absolute;
        bottom: 0.17rem;
        right: 0;
        width: 0.18rem;
        height: 0.14rem;
        background: url("../../assets/images/light_lesson/quotes_r.png") 0 0 /
          cover no-repeat;
      }
      .name {
        margin-top: 0.3rem;
        font-family: PingFangSC-Semibold;
        font-size: 0.32rem;
        color: #206a9b;
        height: 0.31rem;
        line-height: 0.31rem;
      }
      .word {
        margin-top: 0.2rem;
        width: 4.1rem;
        font-family: PingFangSC-Regular;
        font-size: 0.24rem;
        line-height: 0.36rem;
        color: #5099c9;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }
  }
  .content_analysis {
    padding: 0.8rem 0.3rem 0.1rem;
    h3 {
      font-family: "FZY4JW";
      font-size: 0.4rem;
      color: #424243;
      text-align: center;
    }
    h4 {
      margin-top: 0.05rem;
      font-family: PingFangSC-Regular;
      font-size: 0.24rem;
      color: #bec0c2;
      text-align: center;
    }
    .list {
      margin-top: 0.2rem;
      padding: 0.3rem 0.4rem 0;
      height: 2.31rem;
      background-color: #fafafa;
      border-radius: 0.2rem;
      &_mes {
        font-family: PingFangSC-Semibold;
        font-size: 0.24rem;
        color: #4a4b4c;
        line-height: 0.24rem;
        span {
          margin-left: 0.2rem;
          font-family: PingFangSC-Regular;
          font-size: 0.2rem;
          color: #bdbfc2;
        }
      }
      &_p_box {
        position: relative;
        margin: 0.3rem 0 0.2rem;
        height: 0.18rem;
        background-color: #eeeeef;
        border-radius: 0.09rem;
        .p_box_c {
          position: absolute;
          left: 0;
          top: 0;
          width: 2.79rem;
          height: 0.18rem;
          border-radius: 0.09rem;
          background-color: #69c3ff;
          z-index: 99;
        }
        .g_box_c {
          position: absolute;
          top: 0;
          left: 2.7rem;
          height: 0.18rem;
          width: 2.17rem;
          background: url("../../assets/images/light_lesson/g_percent.png") 0 0 /
            cover no-repeat;
          img {
            width: 0.19rem;
            height: 0.24rem;
            margin-top: -0.04rem;
            margin-right: -0.1rem;
            float: right;
          }
        }
      }
      &_s_box {
        .fl_p {
          float: left;
          text-align: center;
          .score {
            display: block;
            font-family: "BebasNeue_Bold";
            font-size: 0.6rem;
            color: #69c3ff;
            line-height: 0.45rem;
            font-weight: bold;
          }
          .word {
            display: block;
            font-family: PingFangSC-Regular;
            font-size: 0.22rem;
            color: #bec0c2;
          }
        }
        .fr_p {
          float: right;
          text-align: center;
          .score {
            display: block;
            font-family: "BebasNeue_Bold";
            font-size: 0.6rem;
            color: #ff7575;
            line-height: 0.45rem;
            font-weight: bold;
          }
          .word {
            display: block;
            font-family: PingFangSC-Regular;
            font-size: 0.22rem;
            color: #bec0c2;
          }
        }
      }
    }
  }
  .content_plan {
    padding: 0.8rem 0.4rem 0.2rem;
    h3 {
      font-family: "FZY4JW";
      font-size: 0.4rem;
      color: #424243;
      text-align: center;
    }
    h4 {
      margin-top: 0.1rem;
      font-family: PingFangSC-Regular;
      font-size: 0.24rem;
      color: #bec0c2;
      text-align: center;
    }
    .plan_item_a {
      margin-top: 0.35rem;
      display: flex;
      .item {
        flex: 1;
        &:first-child {
          margin-right: 0.25rem;
          .plan_box {
            position: relative;
            padding-top: 0.46rem;
            background-color: #d5f1ff;
            color: #44b4ff;
            &:before {
              content: "";
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              margin: auto;
              height: 0.1rem;
              width: 0.16rem;
              background: url("../../assets/images/light_lesson/arrow_down_b.png")
                0 0 / cover no-repeat;
            }
            p {
              padding-left: 0.3rem;
              color: #44b4ff;
              &:first-child {
                font-family: PingFangSC-Regular;
                font-size: 0.22rem;
                line-height: 0.22rem;
              }
              &:last-child {
                margin-top: 0.16rem;
                font-family: PingFangSC-Semibold;
                font-size: 0.32rem;
                line-height: 0.32rem;
              }
            }
            img {
              position: absolute;
              bottom: 0;
              right: 0;
              width: 0.56rem;
              height: 0.9rem;
            }
          }
          span {
            color: #44b4ff;
          }
        }
        &:last-child {
          margin-left: 0.25rem;
          .plan_box {
            padding-top: 0.46rem;
            background-color: #ffe8e7;
            color: #ff7575;
            &:before {
              content: "";
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              margin: auto;
              height: 0.1rem;
              width: 0.16rem;
              background: url("../../assets/images/light_lesson/arrow_down_a.png")
                0 0 / cover no-repeat;
            }
            p {
              padding-left: 0.3rem;
              color: #ff7575;
              &:first-child {
                font-family: PingFangSC-Regular;
                font-size: 0.22rem;
                line-height: 0.22rem;
              }
              &:last-child {
                margin-top: 0.16rem;
                font-family: PingFangSC-Semibold;
                font-size: 0.32rem;
                line-height: 0.32rem;
              }
            }
            img {
              position: absolute;
              bottom: 0;
              right: 0;
              width: 0.62rem;
              height: 0.86rem;
            }
          }
          span {
            color: #ff7575;
          }
        }
        .title {
          font-family: PingFangSC-Regular;
          font-size: 0.28rem;
          color: #919294;
          text-align: center;
          span {
            font-family: PingFangSC-Semibold;
            font-size: 0.36rem;
          }
        }
        .plan_box {
          position: relative;
          margin-top: 0.1rem;
          width: 100%;
          height: 1.6rem;
          border-radius: 0.24rem;
        }
      }
    }
    .plan_item_b {
      margin-top: 0.35rem;
      display: flex;
      .item {
        flex: 1;
        &:first-child {
          margin-right: 0.25rem;
          .plan_box {
            position: relative;
            padding-top: 0.35rem;
            background-color: #d5f1ff;
            color: #44b4ff;
            text-align: center;
            &:before {
              content: "";
              position: absolute;
              left: 0;
              right: 0;
              bottom: 0.2rem;
              margin: auto;
              height: 0.1rem;
              width: 0.16rem;
              background: url("../../assets/images/light_lesson/arrow_down_b.png")
                0 0 / cover no-repeat;
            }
            p {
              color: #44b4ff;
              font-family: PingFangSC-Regular;
              font-size: 0.28rem;
              line-height: 0.32rem;
              &:first-child {
                margin-bottom: 0.05rem;
                font-family: PingFangSC-Semibold;
                font-size: 0.32rem;
                line-height: 0.4rem;
              }
            }
            img {
              position: absolute;
              bottom: 0;
              right: 0;
              width: 0.56rem;
              height: 0.9rem;
            }
          }
          span {
            color: #44b4ff;
          }
        }
        &:last-child {
          /*margin-left: .25rem;*/
          .plan_box {
            padding-top: 0.35rem;
            background-color: #ffe8e7;
            color: #ff7575;
            text-align: center;
            &:before {
              content: "";
              position: absolute;
              left: 0;
              right: 0;
              bottom: 0.2rem;
              margin: auto;
              height: 0.1rem;
              width: 0.16rem;
              background: url("../../assets/images/light_lesson/arrow_down_a.png")
                0 0 / cover no-repeat;
            }
            p {
              color: #ff7575;
              font-family: PingFangSC-Regular;
              font-size: 0.28rem;
              line-height: 0.32rem;
              &:first-child {
                margin-bottom: 0.05rem;
                font-family: PingFangSC-Semibold;
                font-size: 0.32rem;
                line-height: 0.4rem;
              }
            }
            img {
              position: absolute;
              bottom: 0;
              right: 0;
              width: 0.62rem;
              height: 0.86rem;
            }
          }
          span {
            color: #ff7575;
          }
        }
        .title {
          margin-top: 0.2rem;
          height: 0.3rem;
          line-height: 0.3rem;
          font-family: PingFangSC-Regular;
          font-size: 0.26rem;
          color: #919294;
          span {
            font-family: PingFangSC-Semibold;
            font-size: 0.3rem;
          }
        }
        .plan_box {
          position: relative;
          margin-top: 0.1rem;
          width: 100%;
          height: 1.6rem;
          border-radius: 0.24rem;
        }
      }
    }
    img {
      margin-top: 0.3rem;
      width: 100%;
    }
  }
  .content_program {
    padding: 0.8rem 0.4rem 0.2rem;
    h3 {
      font-family: "FZY4JW";
      font-size: 0.4rem;
      color: #424243;
      text-align: center;
    }
    h4 {
      margin-top: 0.1rem;
      font-family: PingFangSC-Regular;
      font-size: 0.24rem;
      color: #bec0c2;
      text-align: center;
      .line {
        margin: 0 0.15rem;
        display: inline-block;
        width: 0.03rem;
        height: 0.16rem;
        background-color: #c7c9cb;
        border-radius: 2px;
      }
    }
    .item {
      width: 100%;
      margin-top: 0.3rem;
      display: inline-block;
      padding: 0.1rem 0.38rem 0.1rem 0.22rem;
      background-color: #fafafa;
      border-radius: 0.2rem;
      .list {
        padding: 0.36rem 0 0 0.04rem;
        height: 1.4rem;
        border-bottom: 0.04rem solid #fff;
        &:last-child {
          border: none;
        }
        span {
          float: left;
          display: block;
          width: 0.68rem;
          height: 0.68rem;
          line-height: 0.8rem;
          background-color: #69c3ff;
          border-radius: 50%;
          text-align: center;
          font-family: "BebasNeue_Bold";
          font-size: 0.44rem;
          color: #fff;
        }
        .r_box {
          margin-left: 0.28rem;
          float: left;
          .title {
            height: 0.35rem;
            line-height: 0.35rem;
            font-family: PingFangSC-Medium;
            font-size: 0.32rem;
            color: #5f6162;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .time {
            margin-top: 0.1rem;
            height: 0.2rem;
            line-height: 0.2rem;
            font-family: PingFangSC-Regular;
            font-size: 0.18rem;
            color: #424243;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
  }
  .content_teacher {
    padding: 0.8rem 0.4rem 0.1rem;
    h3 {
      font-family: "FZY4JW";
      font-size: 0.4rem;
      color: #424243;
      text-align: center;
    }
    h4 {
      margin: 0.2rem 0 0.15rem;
      font-family: PingFangSC-Medium;
      font-size: 0.34rem;
      color: #69c3ff;
      line-height: 0.32rem;
    }
    .item {
      position: relative;
      display: flex;
      margin-top: 0.52rem;
      padding-bottom: 0.74rem;
      border-bottom: 1px solid #f0f0f0;
      .list {
        flex: 1;
        text-align: center;
        img {
          width: 1.2rem;
          height: 1.2rem;
          border: 0.04rem solid #c0e6ff;
          border-radius: 50%;
        }
        p {
          font-family: PingFangSC-Regular;
          font-size: 0.26rem;
          line-height: 0.36rem;
          color: #bec0c2;
          text-align: left;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
          display: -webkit-box;
        }
      }
      .p_r {
        padding-right: 0.45rem;
      }
      .p_l {
        padding-left: 0.45rem;
      }
      .v_s {
        display: inline-block;
        position: absolute;
        width: 0.21rem;
        height: 0.2rem;
        left: 0;
        right: 0;
        top: 1.48rem;
        margin: auto;
        font-family: "BebasNeue_Bold";
        font-size: 0.28rem;
        color: #d5f1ff;
      }
    }
  }
  .content_flow {
    margin-bottom: 1rem;
    padding: 0.8rem 0.4rem 0.4rem;
    h3 {
      font-family: "FZY4JW";
      font-size: 0.4rem;
      color: #424243;
      text-align: center;
    }
    img {
      margin-top: 0.3rem;
      width: 100%;
    }
  }
  .bottom_btn {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1rem;
    z-index: 99;
    .l_box {
      float: left;
      padding: 0.25rem 0;
      width: 4.9rem;
      height: 1rem;
      background: #fff;
      /*box-shadow: 10px 10px 5px #40384e;*/
      box-shadow: 0px -2px 8px 0px rgba(64, 56, 78, 0.08);
      h3 {
        &:before {
          content: "¥";
          font-family: "BebasNeue_Bold";
          font-size: 0.44rem;
          color: #ff7575;
        }
        display: inline-block;
        margin-left: 0.3rem;
        margin-right: 0.2rem;
        font-family: "BebasNeue_Bold";
        font-size: 0.72rem;
        color: #ff7575;
        float: left;
      }
      span {
        display: block;
        font-family: PingFangSC-Regular;
        font-size: 0.26rem;
        line-height: 0.25rem;
        color: #5f6162;
        &:last-child {
          margin-top: 0.1rem;
          font-family: "BebasNeue_Bold";
          font-size: 0.24rem;
          color: #ff9b9b;
          text-decoration: line-through;
        }
      }
    }
    .r_box {
      height: 1rem;
      line-height: 1rem;
      font-family: PingFangSC-Semibold;
      font-size: 0.34rem;
      color: #fff;
      text-align: center;
      background: #ff7575;
      overflow: hidden;
    }
  }
}
/*iPhone X XS 2436x1125px at 458ppi */
@media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
  .head_item {
    margin-top: constant(safe-area-inset-top);
    margin-top: env(safe-area-inset-top);
    i {
      top: calc(0.2rem + constant(safe-area-inset-top));
    }
  }
}

/*iPhone XR 1792x828px at 326ppi */
@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) {
  .head_item {
    margin-top: constant(safe-area-inset-top);
    margin-top: env(safe-area-inset-top);
    i {
      top: calc(0.2rem + constant(safe-area-inset-top));
    }
  }
}

/* iPhone XS Max 2688x1242px at 458ppi */
@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) {
  .head_item {
    margin-top: constant(safe-area-inset-top);
    margin-top: env(safe-area-inset-top);
    i {
      top: calc(0.2rem + constant(safe-area-inset-top));
    }
  }
}
</style>